var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menu",
    attrs: {
      "role": "menu"
    }
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("bioplan architekten")])], 1)]), _vm._v(" "), _c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Archive'
      }
    }
  }, [_vm._v("archiv")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Office'
      }
    }
  }, [_vm._v("büro")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "active",
    attrs: {
      "to": {
        name: 'Contact'
      }
    }
  }, [_vm._v("contact")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [(_vm.isLoading) ? _c('LoadingSpinner') : [_c('div', {
    staticClass: "left font-regular",
    domProps: {
      "innerHTML": _vm._s(_vm.textHtml)
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('iframe', {
    staticClass: "map",
    staticStyle: {
      "border": "none"
    },
    attrs: {
      "src": "https://snazzymaps.com/embed/6656",
      "width": "100%",
      "height": "600px"
    }
  })])]], 2), _vm._v(" "), _vm._m(0)])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "information"
  }, [_c('img', {
    staticClass: "signet",
    attrs: {
      "src": require("../../assets/img/bioplan_signet.png"),
      "height": "57",
      "width": "72"
    }
  })])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4339ed83","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Contact.vue
// module id = 176
// module chunks = 1